import { useRef } from 'react';
import { useNavigate as useRouterNavigate, } from 'react-router-dom';
import { ROUTES } from "../../routes";
export function getSparkflowNavService(navigate) {
    return {
        goToUseCase: () => {
            navigate(`/sparkflow/onboarding/${ROUTES.UseCase.path}`);
        },
        navigate,
    };
}
export function useSparkflowNavService() {
    const navigate = useRouterNavigate();
    const navService = useRef(null);
    if (!navService.current) {
        navService.current = getSparkflowNavService(navigate);
    }
    return navService.current;
}
//# sourceMappingURL=nav-service.js.map